export default [
  {
    name: 'name',
    type: 'text-field',
    flex: {
      sm6: true,
    },
    props: {
      label: 'Nombre Oferta',
    },
  },
]
